// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Red_Hat_Display/static/RedHatDisplay-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Montserrat/static/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/img/sky.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
html {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

@font-face {
  font-family: "big";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "paragraph";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
h1 {
  font-size: 80px;
  margin: 24px 0px;
  font-family: "big";
  text-align: center;
  color: rgb(69, 102, 124);
}

h2,
h3 {
  font-size: 40px;
  margin: 24px 0px;
  font-family: "big";
  text-align: center;
  color: rgb(69, 102, 124);
}

h4,
p,
a,
button,
label,
input {
  font-size: 24px;
  font-family: "paragraph";
  line-height: 1.6em;
}

button {
  margin: 16px 0px;
  padding: 8px 16px;
  border: 4px solid rgb(69, 102, 124);
  border-radius: 500px;
  background-color: white;
  color: rgb(31, 33, 26);
  transition: background-color 0.3s ease;
}
button:hover {
  cursor: pointer;
  background-color: rgb(69, 102, 124);
  color: rgb(241, 243, 255);
  transition: background-color 0.3s ease;
}

.mobile-only {
  display: none;
}

.down-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 24px;
  z-index: 2;
}
.down-btn .arrow {
  position: relative;
  height: 80px;
  width: 80px;
}
.down-btn .arrow .straight,
.down-btn .arrow .left,
.down-btn .arrow .right {
  position: absolute;
  display: inline-block;
  height: 2px;
  background-color: rgb(31, 33, 26);
}
.down-btn .arrow .straight {
  transform: rotate(90deg);
  top: 35px;
  left: 20px;
  width: 40px;
}
.down-btn .arrow .left {
  transform: rotate(45deg);
  top: 48px;
  left: 20px;
  width: 24px;
}
.down-btn .arrow .right {
  transform: rotate(-45deg);
  top: 48px;
  right: 20px;
  width: 24px;
}
.down-btn:hover {
  cursor: pointer;
}

@media screen and (max-width: 980px) {
  h1 {
    font-size: 40px;
  }
  h2,
  h3 {
    font-size: 32px;
  }
  h4,
  p,
  a,
  button,
  label,
  input {
    font-size: 20px;
  }
  .mobile-only {
    display: flex;
  }
}
.aboutus-page .about-us {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: rgb(241, 243, 255);
  position: relative;
}
.aboutus-page .about-us .top {
  width: 100%;
  min-height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.aboutus-page .about-us .top .text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  z-index: 4;
}
.aboutus-page .about-us .top .text h1,
.aboutus-page .about-us .top .text p {
  width: 50%;
}
.aboutus-page .about-us .top .portrait {
  position: absolute;
  top: 50%;
  right: 32vw;
  transform: translate(50%, -50%);
  width: 30%;
  object-fit: contain;
  z-index: 2;
}
.aboutus-page .about-us .top span.side {
  position: absolute;
  top: 0;
  right: 0;
  width: 32vw;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: bottom left;
  z-index: 0;
}
.aboutus-page .about-us .top span.transition {
  position: absolute;
  top: 0;
  right: 33vw;
  width: 10vw;
  transform: translateX(100%);
  height: 100%;
  background: linear-gradient(to left, transparent, rgb(241, 243, 255));
  z-index: 1;
}
.aboutus-page .about-us .down-btn {
  position: relative;
}
.aboutus-page .resume span.transition {
  display: block;
  width: 100vw;
  height: 120px;
}
.aboutus-page .resume span.transition.top {
  background: linear-gradient(to top, white, rgb(241, 243, 255), rgb(241, 243, 255));
}
.aboutus-page .resume span.transition.bottom {
  background: linear-gradient(to bottom, white, rgb(241, 243, 255), rgb(241, 243, 255));
}
.aboutus-page .resume .list {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
}
.aboutus-page .resume .list li.certification {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 600px;
  text-align: center;
  padding: 40px;
}
.aboutus-page .resume .list li.certification img {
  height: 100px;
}
.aboutus-page .resume .list li.certification h3 {
  font-size: 32px;
}
.aboutus-page .resume .list li.certification h3 a {
  font-size: 32px;
  font-family: "big";
  color: rgb(69, 102, 124);
}
.aboutus-page .resume .list li.certification p a {
  color: rgb(31, 33, 26);
}
.aboutus-page .resume .list li.certification .additional-info img:nth-of-type(1) {
  width: 50%;
  object-fit: cover;
}
.aboutus-page .resume .list li.certification .additional-info img:nth-of-type(2) {
  width: 50%;
  object-fit: contain;
}
.aboutus-page .resume .list li.certification#bigger-logo img {
  height: 180px;
}
.aboutus-page .resume .list li.certification#bigger-logo h3 {
  margin-top: 0px;
}
.aboutus-page .resume .down-btn {
  position: relative;
}
.aboutus-page .about-patients {
  background-color: rgb(241, 243, 255);
}
.aboutus-page .about-patients h2 {
  margin: 0;
  padding: 24px;
}
.aboutus-page .about-patients .list-container {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
}
.aboutus-page .about-patients .list-container .card {
  width: 445px;
  margin: 48px;
  min-height: 50vh;
  background: linear-gradient(to top, transparent, transparent, #dcd2e0, #dacce0);
  box-shadow: 0px 17px 19px 0px #c6bcca;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.aboutus-page .about-patients .list-container .card .title {
  color: white;
  padding: 24px;
  margin: 0px;
}
.aboutus-page .about-patients .list-container .card .description {
  padding: 24px;
  text-align: start;
}

@media screen and (max-width: 980px) {
  .aboutus-page .about-us {
    justify-content: center;
    flex-direction: column;
  }
  .aboutus-page .about-us .down-btn {
    padding-top: 40px;
  }
  .aboutus-page .about-us .top {
    flex-direction: column-reverse;
    height: -moz-fit-content;
    height: fit-content;
  }
  .aboutus-page .about-us .top .text h1,
  .aboutus-page .about-us .top .text p {
    width: 100%;
  }
  .aboutus-page .about-us .top .portrait {
    position: relative;
    top: auto;
    right: auto;
    transform: translate(0, 0);
    width: 50%;
  }
  .aboutus-page .about-us .top span.side {
    width: 100%;
    height: 30vh;
    background-size: 100% auto;
  }
  .aboutus-page .about-us .top span.transition {
    top: 21vh;
    right: 0;
    width: 100%;
    transform: translateX(0%);
    height: 10vh;
    background: linear-gradient(to bottom, transparent, rgb(241, 243, 255));
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss","webpack://./src/styles/aboutus.scss"],"names":[],"mappings":"AASA;;EAEE,UAAA;EACA,SAAA;EACA,sBAAA;ACRF;;ADWA;EACE,kBAAA;EACA,4CAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;ACTF;ADYA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBA7Bc;ACmBhB;;ADaA;;EAEE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBAtCc;AC4BhB;;ADaA;;;;;;EAME,eAAA;EACA,wBAAA;EACA,kBAAA;ACVF;;ADaA;EACE,gBAAA;EACA,iBAAA;EACA,mCAAA;EACA,oBAnDO;EAoDP,uBAAA;EACA,sBA3DW;EA4DX,sCAAA;ACVF;ADYE;EACE,eAAA;EACA,mCA/DY;EAgEZ,yBAlEU;EAmEV,sCAAA;ACVJ;;ADcA;EACE,aAAA;ACXF;;ADcA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;ACXF;ADaE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;ACXJ;ADaI;;;EAGE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,iCA9FO;ACmFb;ADcI;EACE,wBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;ACZN;ADeI;EACE,wBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;ACbN;ADgBI;EACE,yBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;ACdN;ADkBE;EACE,eAAA;AChBJ;;ADoBA;EACE;IACE,eAAA;ECjBF;EDoBA;;IAEE,eAAA;EClBF;EDqBA;;;;;;IAME,eAAA;ECnBF;EDsBA;IACE,aAAA;ECpBF;AACF;AA3HE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oCDTU;ECUV,kBAAA;AA6HJ;AA3HI;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA6HN;AA3HM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;AA6HR;AA3HQ;;EAEE,UAAA;AA6HV;AAzHM;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,+BAAA;EACA,UAAA;EACA,mBAAA;EACA,UAAA;AA2HR;AAxHM;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,0BAAA;EACA,4BAAA;EACA,gCAAA;EACA,UAAA;AA0HR;AAvHM;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,2BAAA;EACA,YAAA;EACA,qEAAA;EACA,UAAA;AAyHR;AArHI;EACE,kBAAA;AAuHN;AAlHI;EACE,cAAA;EACA,YAAA;EACA,aAAA;AAoHN;AAlHM;EACE,kFAAA;AAoHR;AAjHM;EACE,qFAAA;AAmHR;AA1GI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;AA4GN;AA1GM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AA4GR;AA1GQ;EACE,aAAA;AA4GV;AAzGQ;EACE,eAAA;AA2GV;AAzGU;EACE,eAAA;EACA,kBAAA;EACA,wBDrHI;ACgOhB;AAtGU;EACE,sBD5HC;ACoOb;AAnGU;EACE,UAAA;EACA,iBAAA;AAqGZ;AAnGU;EACE,UAAA;EACA,mBAAA;AAqGZ;AAhGU;EACE,aAAA;AAkGZ;AA/FU;EACE,eAAA;AAiGZ;AA3FI;EACE,kBAAA;AA6FN;AAzFE;EACE,oCD9JU;ACyPd;AAzFI;EACE,SAAA;EACA,aAAA;AA2FN;AAxFI;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;AA0FN;AAxFM;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,+EAAA;EAOA,qCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;AAoFR;AAlFQ;EACE,YAAA;EACA,aAAA;EACA,WAAA;AAoFV;AAjFQ;EACE,aAAA;EACA,iBAAA;AAmFV;;AA5EA;EAEI;IACE,uBAAA;IACA,sBAAA;EA8EJ;EA5EI;IACE,iBAAA;EA8EN;EA3EI;IACE,8BAAA;IACA,wBAAA;IAAA,mBAAA;EA6EN;EA1EQ;;IAEE,WAAA;EA4EV;EAxEM;IACE,kBAAA;IACA,SAAA;IACA,WAAA;IACA,0BAAA;IACA,UAAA;EA0ER;EAvEM;IACE,WAAA;IACA,YAAA;IACA,0BAAA;EAyER;EAtEM;IACE,SAAA;IACA,QAAA;IACA,WAAA;IACA,yBAAA;IACA,YAAA;IACA,uEAAA;EAwER;AACF","sourcesContent":["$light-color: rgb(241, 243, 255);\n$dark-color: rgb(31, 33, 26);\n$primary-color: rgb(69, 102, 124);\n$secondary-color: rgb(43, 45, 36);\n\n$mobile-width: 980px;\n\n$radius: 500px;\n\n*,\nhtml {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n@font-face {\n  font-family: \"big\";\n  src: url(\"../assets/fonts/Red_Hat_Display/static/RedHatDisplay-Medium.ttf\");\n}\n\n@font-face {\n  font-family: \"paragraph\";\n  src: url(\"../assets/fonts/Montserrat/static/Montserrat-Regular.ttf\");\n}\n\nh1 {\n  font-size: 80px;\n  margin: 24px 0px;\n  font-family: \"big\";\n  text-align: center;\n  color: $primary-color;\n}\n\nh2,\nh3 {\n  font-size: 40px;\n  margin: 24px 0px;\n  font-family: \"big\";\n  text-align: center;\n  color: $primary-color;\n}\n\nh4,\np,\na,\nbutton,\nlabel,\ninput {\n  font-size: 24px;\n  font-family: \"paragraph\";\n  line-height: 1.6em;\n}\n\nbutton {\n  margin: 16px 0px;\n  padding: 8px 16px;\n  border: 4px solid $primary-color;\n  border-radius: $radius;\n  background-color: white;\n  color: $dark-color;\n  transition: background-color 0.3s ease;\n\n  &:hover {\n    cursor: pointer;\n    background-color: $primary-color;\n    color: $light-color;\n    transition: background-color 0.3s ease;\n  }\n}\n\n.mobile-only {\n  display: none;\n}\n\n.down-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  bottom: 24px;\n  z-index: 2;\n\n  .arrow {\n    position: relative;\n    height: 80px;\n    width: 80px;\n\n    .straight,\n    .left,\n    .right {\n      position: absolute;\n      display: inline-block;\n      height: 2px;\n      background-color: $dark-color;\n    }\n\n    .straight {\n      transform: rotate(90deg);\n      top: 35px;\n      left: 20px;\n      width: 40px;\n    }\n\n    .left {\n      transform: rotate(45deg);\n      top: 48px;\n      left: 20px;\n      width: 24px;\n    }\n\n    .right {\n      transform: rotate(-45deg);\n      top: 48px;\n      right: 20px;\n      width: 24px;\n    }\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n@media screen and (max-width: $mobile-width) {\n  h1 {\n    font-size: 40px;\n  }\n\n  h2,\n  h3 {\n    font-size: 32px;\n  }\n\n  h4,\n  p,\n  a,\n  button,\n  label,\n  input {\n    font-size: 20px;\n  }\n\n  .mobile-only {\n    display: flex;\n  }\n}\n","@import \"./main.scss\";\n\n.aboutus-page {\n  .about-us {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 100vh;\n    background-color: $light-color;\n    position: relative;\n\n    .top {\n      width: 100%;\n      min-height: 80vh;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      .text {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: center;\n        text-align: center;\n        z-index: 4;\n\n        h1,\n        p {\n          width: 50%;\n        }\n      }\n\n      .portrait {\n        position: absolute;\n        top: 50%;\n        right: 32vw;\n        transform: translate(50%, -50%);\n        width: 30%;\n        object-fit: contain;\n        z-index: 2;\n      }\n\n      span.side {\n        position: absolute;\n        top: 0;\n        right: 0;\n        width: 32vw;\n        height: 100%;\n        background-image: url(\"../assets/img/sky.png\");\n        background-size: auto 100%;\n        background-repeat: no-repeat;\n        background-position: bottom left;\n        z-index: 0;\n      }\n\n      span.transition {\n        position: absolute;\n        top: 0;\n        right: 33vw;\n        width: 10vw;\n        transform: translateX(100%);\n        height: 100%;\n        background: linear-gradient(to left, transparent, $light-color);\n        z-index: 1;\n      }\n    }\n\n    .down-btn {\n      position: relative;\n    }\n  }\n\n  .resume {\n    span.transition {\n      display: block;\n      width: 100vw;\n      height: 120px;\n\n      &.top {\n        background: linear-gradient(to top, white, $light-color, $light-color);\n      }\n\n      &.bottom {\n        background: linear-gradient(\n          to bottom,\n          white,\n          $light-color,\n          $light-color\n        );\n      }\n    }\n\n    .list {\n      display: flex;\n      flex-wrap: wrap;\n      flex-direction: row;\n      align-items: flex-start;\n      justify-content: center;\n\n      li.certification {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        width: 600px;\n        text-align: center;\n        padding: 40px;\n\n        img {\n          height: 100px;\n        }\n\n        h3 {\n          font-size: 32px;\n\n          a {\n            font-size: 32px;\n            font-family: \"big\";\n            color: $primary-color;\n          }\n        }\n\n        p {\n          a {\n            color: $dark-color;\n          }\n        }\n\n        .additional-info {\n          img:nth-of-type(1) {\n            width: 50%;\n            object-fit: cover;\n          }\n          img:nth-of-type(2) {\n            width: 50%;\n            object-fit: contain;\n          }\n        }\n\n        &#bigger-logo {\n          img {\n            height: 180px;\n          }\n\n          h3 {\n            margin-top: 0px;\n          }\n        }\n      }\n    }\n\n    .down-btn {\n      position: relative;\n    }\n  }\n\n  .about-patients {\n    background-color: $light-color;\n\n    h2 {\n      margin: 0;\n      padding: 24px;\n    }\n\n    .list-container {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: flex-start;\n      justify-content: center;\n\n      .card {\n        width: 445px;\n        margin: 48px;\n        min-height: 50vh;\n        background: linear-gradient(\n          to top,\n          transparent,\n          transparent,\n          #dcd2e0,\n          #dacce0\n        );\n        box-shadow: 0px 17px 19px 0px #c6bcca;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: space-around;\n\n        .title {\n          color: white;\n          padding: 24px;\n          margin: 0px;\n        }\n\n        .description {\n          padding: 24px;\n          text-align: start;\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: $mobile-width) {\n  .aboutus-page {\n    .about-us {\n      justify-content: center;\n      flex-direction: column;\n\n      .down-btn {\n        padding-top: 40px;\n      }\n\n      .top {\n        flex-direction: column-reverse;\n        height: fit-content;\n\n        .text {\n          h1,\n          p {\n            width: 100%;\n          }\n        }\n\n        .portrait {\n          position: relative;\n          top: auto;\n          right: auto;\n          transform: translate(0, 0);\n          width: 50%;\n        }\n\n        span.side {\n          width: 100%;\n          height: 30vh;\n          background-size: 100% auto;\n        }\n\n        span.transition {\n          top: 21vh;\n          right: 0;\n          width: 100%;\n          transform: translateX(0%);\n          height: 10vh;\n          background: linear-gradient(to bottom, transparent, $light-color);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
